export default "__VITE_ASSET__CWMjwo0U__"